import React from 'react';
import { Building2, Cross, Plane, MapPin } from 'lucide-react';

const locationData = [
  {
    name: 'Corporate Parks',
    icon: Building2,
    description: 'Modern office complexes and tech parks',
    color: '#59642C',
  },
  {
    name: 'Hospitals',
    icon: Cross,
    description: 'Healthcare facilities and medical centers',
    color: '#961B1F',
  },
  {
    name: 'Airports',
    icon: Plane,
    description: 'International and domestic terminals',
    color: '#FE9E1C',
  },
];

export const LocationsSection = () => {
  return (
    <section id="locations" className="py-24 bg-white">
      <div className="container mx-auto px-4 lg:px-8">
        <div className="max-w-6xl mx-auto">
          {/* Section Header */}
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold text-[#59642C] mb-6">
              Where We Operate
            </h2>
            <div className="w-24 h-1 bg-[#FE9E1C] mx-auto mb-6"></div>
            <p className="text-xl text-gray-600">
              Designed for modern workplaces
            </p>
          </div>

          {/* Locations Grid */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-16">
            {locationData.map((location, index) => {
              const Icon = location.icon;
              return (
                <div
                  key={index}
                  className="group relative bg-gradient-to-br from-[#EBEBD3]/30 to-white p-10 rounded-3xl hover:shadow-xl transition-all duration-300 hover:-translate-y-1 border border-[#EBEBD3]"
                >
                  {/* Icon */}
                  <div
                    className="w-16 h-16 rounded-2xl flex items-center justify-center mb-6 transition-all duration-300 group-hover:scale-110"
                    style={{ backgroundColor: `${location.color}20` }}
                  >
                    <Icon className="w-8 h-8" style={{ color: location.color }} strokeWidth={2} />
                  </div>

                  {/* Content */}
                  <h3 className="text-2xl font-bold text-[#59642C] mb-3">
                    {location.name}
                  </h3>
                  <p className="text-gray-600">
                    {location.description}
                  </p>

                  {/* Pin Icon */}
                  <MapPin
                    className="absolute top-8 right-8 opacity-10 group-hover:opacity-20 transition-opacity duration-300"
                    size={48}
                    style={{ color: location.color }}
                  />
                </div>
              );
            })}
          </div>

          {/* Illustration Map */}
          <div className="relative bg-gradient-to-br from-[#59642C]/5 to-[#EBEBD3]/30 rounded-3xl p-12 overflow-hidden">
            <div className="relative z-10 text-center">
              <h3 className="text-2xl font-bold text-[#59642C] mb-4">
                Expanding Across Major Cities
              </h3>
              <p className="text-gray-600 text-lg max-w-2xl mx-auto">
                Our kiosks are strategically located in high-footfall corporate environments, bringing fresh, chef-curated food closer to where you work.
              </p>
            </div>

            {/* Decorative Map Elements */}
            <div className="absolute inset-0 opacity-5">
              <div className="absolute top-10 left-10 w-3 h-3 bg-[#FE9E1C] rounded-full animate-pulse"></div>
              <div className="absolute top-20 right-20 w-3 h-3 bg-[#961B1F] rounded-full animate-pulse delay-100"></div>
              <div className="absolute bottom-20 left-1/4 w-3 h-3 bg-[#59642C] rounded-full animate-pulse delay-200"></div>
              <div className="absolute bottom-10 right-1/3 w-3 h-3 bg-[#FE9E1C] rounded-full animate-pulse delay-300"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
